/**
 * 如果Component不会被其他地方复用，没有必要增加文件
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import Clipboard from 'clipboard';
import {Page, Preload} from '../components';
import {LoadMore, Button} from 'react-weui';
import {renderMoney, isLZWKAPP, judgeAPPVersion} from '../utils';
import shareImg from '../images/coupon/share-icon.png'
import { WKVisible } from '../components/wk'

import '../css/page/CouponSharePage.css';


class CouponSharePage extends Component {
    constructor() {
        super()
        this.state = {
            initialized: false,
            coupon: {},
            self: {}
        };
        this.handleShare = this.handleShare.bind(this);
    }

    componentDidMount() {
        const {liveroom_id, coupon_id} = this.props.params
        axios.get(`/api/liveroom/${liveroom_id}/coupon/${coupon_id}/info`).then((res) => {
            if (res.data.code === 0) {
                const {data} = res.data
                /* 如果不是管理员，那么跳转 */
                if(!data.is_manager){
                    window.location = data.share_info.share_url
                    return
                }
                this.setState({
                    initialized: true,
                    coupon: data.coupon,
                    self: data.self,
                    share_info: data.share_info,
                    short_url: data.short_url
                })
                if (data.coupon.scope === 'channel') {
                    this.updateShareInfo({
                        share_title: `微课优惠券：${data.coupon.coupon_name}`,
                        share_description: `价值${renderMoney(data.coupon.price)}元！快抢`,
                        share_icon: shareImg,
                        share_url: data.share_info.share_url,
                    })
                } else {
                    this.updateShareInfo(data.share_info)
                }
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg
                    }
                })
            }
        }).catch((error) => {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '读取错误：' + error
                }
            })
        })
    }

    updateShareInfo(share_info){
        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: 'link',
                link: share_info.share_url
            }
        })

        let clipboard = new Clipboard('#button_copy');
        clipboard.on('success', (e) => {
            this.page.showAlert('已复制到剪贴板');
            e.clearSelection();
        });
    }

    handleShare(){
        const {share_info} = this.state;
        if (window.systemType === 'ios') {
            let dic = {
                function: 'shareUrl',
                json: share_info
            };
            window.webkit.messageHandlers.WKApp.postMessage(dic);
        }

        if(window.systemType === 'android'){
            WKApp.shareUrl (share_info.share_title,share_info.share_description,share_info.share_url,share_info.share_icon);
        }
    }

    render() {
        // console.log(this.props)
        const {wechat} = this.props;

        if (!this.state.initialized) {
            return <Preload />
        }

        const {coupon, share_info, short_url} = this.state;

        let shouldShowCoupon = isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(360)) || (window.systemType === 'android' && judgeAPPVersion(260)));

        if(window.platform === 'weixin'){
            if(!wechat.ready || wechat.shareData.link !== share_info.share_url){
                return <Page parent={this}>
                   <p style={{color: "#fff", textAlign: "center", marginTop: "100px"}}>正在初始化JSSDK，请稍后...</p>
                   <LoadMore loading></LoadMore>
                </Page>
            }
        }

        return (
            <Page parent={this}>
                <div className="coupon-share-page">
                    <div className="box discount-share">
                        <div className="discount-lecture">
                            <p className="text-center">{coupon.object_name}</p>
                            <span className="line-circle left-circle"/>
                            <span className="line-circle right-circle"/>
                        </div>
                        <div className="discount-price">
                            <WKVisible create={coupon.threshold_enabled}>
                                <p className="text-center">{coupon.scope_name}（满￥{renderMoney(coupon.threshold_price)}可用）</p>
                            </WKVisible>
                            <WKVisible create={!coupon.threshold_enabled}>
                                <p className="text-center">{coupon.scope_name}</p>
                            </WKVisible>
                            <p className="discount-price-val">¥{renderMoney(coupon.price)}</p>
                        </div>
                        <div className="discount-rules">
                            <p className="discount-rules-title">使用规则</p>
                            {window.platform === 'weixin' ?
                                <p>1. 点击右上角，分享给好友</p>
                                :
                                <p>1. 点击下面“复制链接”按钮，分享给好友</p>
                            }
                            <p>2. 好友点击你分享的链接后即可领取优惠券</p>
                        </div>


                        <div className="discount-link" style={{height: shouldShowCoupon ? '150px' : 'auto'}}>
                            <div className="title">
                                短链接
                            </div>
                            <div className="content">
                                <div className="link">
                                    <p>{short_url}</p>
                                    <p id="button_copy" data-clipboard-text={short_url}>复制</p>
                                </div>
                            </div>
                            {shouldShowCoupon &&
                            <div className="button">
                                <Button className="button-share" onClick={this.handleShare}>分享优惠券</Button>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </Page>
        )
    }
}


export default connect((state) => ({
    wechat: state.wechat
}))(CouponSharePage)



// WEBPACK FOOTER //
// ./src/pages/CouponSharePage.js